import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

const categoryImages: Record<string, string> = {
  dianshiju: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20large%20TV%20screen%20showing%20dramatic%20scene%2C%20warm%20ambient%20lighting%2C%20comfortable%20sofa%2C%20modern%20home%20theater%20setup%2C%20cinematic%20color%20grading%2C%20soft%20glow&width=600&height=400&seq=taohua-cat-tv&orientation=landscape',
  dianying: 'https://readdy.ai/api/search-image?query=Cinema%20theater%20interior%20with%20red%20velvet%20seats%20and%20large%20silver%20screen%2C%20dramatic%20stage%20lighting%2C%20empty%20theater%20before%20show%2C%20elegant%20atmosphere%2C%20warm%20golden%20accents&width=600&height=400&seq=taohua-cat-movie&orientation=landscape',
  zongyi: 'https://readdy.ai/api/search-image?query=Bright%20TV%20studio%20set%20with%20colorful%20stage%20lights%2C%20game%20show%20atmosphere%2C%20modern%20variety%20show%20production%2C%20dynamic%20lighting%20setup%2C%20vibrant%20entertainment%20scene&width=600&height=400&seq=taohua-cat-variety&orientation=landscape',
  dongman: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20art%20studio%20with%20drawing%20tablets%20and%20character%20sketches%2C%20vibrant%20illustration%20style%2C%20creative%20workspace%2C%20warm%20lighting%2C%20Japanese%20animation%20aesthetic&width=600&height=400&seq=taohua-cat-anime&orientation=landscape',
  jilupian: 'https://readdy.ai/api/search-image?query=Professional%20documentary%20filmmaking%20setup%20in%20nature%2C%20camera%20on%20tripod%20facing%20beautiful%20landscape%2C%20golden%20hour%20lighting%2C%20cinematic%20outdoor%20scene%2C%20wildlife%20photography%20vibe&width=600&height=400&seq=taohua-cat-doc&orientation=landscape',
};

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            影视分类
          </h2>
          <p className="text-sm text-foreground-600">海量资源，分类浏览，快速找到你想看的</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-xl overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={categoryImages[cat.slug]}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg mb-2 group-hover:scale-110 transition-transform">
                  <i className={`${cat.icon} text-white text-lg`}></i>
                </div>
                <p className="text-white font-heading font-semibold text-base md:text-lg">{cat.name}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}